var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import './JourneyCompleted.scss';
import { CLASSNAME_PREFIX as cp } from './componentConfig';
function JourneyCompleted(_a) {
    var verified = _a.verified, translate = _a.t;
    var _b = __read(React.useState(10), 2), counter = _b[0], setCounter = _b[1];
    var runCounter = function () {
        var intervalId = window.setInterval(function () {
            setCounter(function (counterValue) {
                if (counterValue === 1) {
                    window.clearInterval(intervalId);
                    window.open(window.avAppConfig.registrationUrl, '_self');
                }
                return counterValue - 1;
            });
        }, 1000);
        return intervalId;
    };
    React.useEffect(function () {
        if (verified) {
            var timer_1 = runCounter();
            return function () { return window.clearInterval(timer_1); };
        }
        return;
    }, []);
    return (React.createElement("div", { className: cp + "-component" },
        React.createElement("h3", null, translate('JOURNEY_COMPLETED_TITLE')),
        verified ? (React.createElement("p", null, translate('VERIFICATION_COMPLETED'))) : (React.createElement("div", null,
            React.createElement("p", null, translate('SUBMIT_CONFIRMATION')),
            React.createElement("span", { className: cp + "-component__highlighted-text" }, translate('SUBMIT_CONFIRMATION_TERM')))),
        React.createElement("span", { className: cp + "-component__icon" }),
        verified ? (React.createElement("p", null,
            translate('VERIFICATION_COMPLETED_BUTTON_LABEL'),
            React.createElement("a", { className: cp + "-component__button", href: window.avAppConfig.registrationUrl },
                translate('VERIFICATION_COMPLETED_BUTTON_VALUE'),
                " (",
                counter,
                ")"))) : (React.createElement("p", null, translate('SUBMIT_CONFIRMATION_FINISHED')))));
}
export default JourneyCompleted;
//# sourceMappingURL=JourneyCompleted.js.map